module.exports = __webpack_public_path__ + "img/connections.29008726.png";